import React, { useState } from 'react';
import { Button, InputNumber, Modal, message } from 'antd';
import { directOrderService } from '../../../services/directOrderService';

// The counter new direct orders are numbered from.
const ReferencePanel = ({ reference, onUpdated }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(reference);
  const [saving, setSaving] = useState(false);

  const openModal = () => {
    setValue(reference);
    setOpen(true);
  };

  const handleUpdate = async () => {
    if (!value || value === reference) {
      setOpen(false);
      return;
    }

    try {
      setSaving(true);
      const result = await directOrderService.updateReference(value);

      if (result.success) {
        message.success(`Reference number updated to ${result.newReference}`);
        onUpdated(result.newReference);
        setOpen(false);
      } else {
        message.error('Failed to update reference number');
      }
    } catch (error) {
      message.error('Failed to update reference number');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="do-panel">
      <div className="do-setting">
        <div>
          <h2 className="do-panel__title">Current reference number</h2>
          <p className="do-panel__hint">The next direct order is numbered from this value.</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span className="do-setting__value">{reference ?? '—'}</span>
          <Button onClick={openModal}>Change</Button>
        </div>
      </div>

      <Modal
        title="Change reference number"
        open={open}
        onOk={handleUpdate}
        onCancel={() => setOpen(false)}
        okText="Update reference"
        cancelText="Cancel"
        confirmLoading={saving}
        okButtonProps={{ disabled: !value || value === reference }}
        rootClassName="do-root do-scope"
        width={440}
      >
        <p className="do-muted" style={{ margin: '0 0 16px' }}>
          Current reference: <strong className="do-num" style={{ color: 'var(--do-ink)' }}>{reference}</strong>. New direct orders
          will use the number you set here.
        </p>
        <label htmlFor="do-new-reference" style={{ display: 'block', fontWeight: 500, marginBottom: 6 }}>
          New reference number
        </label>
        <InputNumber id="do-new-reference" style={{ width: '100%' }} value={value} onChange={setValue} min={1} precision={0} />
      </Modal>
    </section>
  );
};

export default ReferencePanel;
